/*
 * @Descripttion:
 * @Author: huangqiang
 * @version:
 * @Date: 2023-02-08 19:47:07
 * @LastEditors: huangqiang
 * @LastEditTime: 2023-03-10 18:08:30
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/chat'
  },
  {
    path: '/chat_af',
    name: 'ChatAOFEI',
    component: () => import('../views/ChatForAF.vue'),
    meta: { keepAlive: true }
  },
  // {
  //   path: '/chat',
  //   name: 'Chat',
  //   component: () => import('../views/Chat.vue'),
  //   meta: { keepAlive: true }
  // },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('../views/Chat1.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/tips',
    name: 'Tips',
    component: () => import('../views/Tips.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
